import { PolicyService } from 'wmic-pe-capability-gateway-policy';
import constants from '../../constants.js';
import WMICTabsCommonUtil from '../components/WMICTabsCommonUtil';
import messages from '../WMICLanding.messages';

const getPolicyNumberLink = (element, translator) => WMICTabsCommonUtil.getPolicyNumberLink(element, translator);

const displayColumns = translator => [
    {
        id: 'name',
        path: 'name',
        headerClassName: 'headerText',
        textAlign: 'left',
        header: {
            id: 'issued.agent.directives.PolicySummary.Client Name',
            defaultMessage: 'meta.Name',
        },
    },
    {
        id: 'address',
        path: 'address',
        headerClassName: 'headerText',
        textAlign: 'left',
        columnProportion: 2,
        header: {
            id: 'issued.agent.directives.PolicySummary.Policy Address',
            defaultMessage: 'meta.Address',
        },
    },
    {
        id: 'jobNumber',
        path: 'jobNumber',
        headerClassName: 'headerText',
        renderCell: rowData => getPolicyNumberLink(rowData, translator),
        textAlign: 'left',
        header: {
            id: 'issued.agent.directives.PolicySummary.Policy Number',
            defaultMessage: 'meta.Policy',
        },
    },
    {
        id: 'broker',
        path: 'broker',
        headerClassName: 'headerText',
        textAlign: 'left',
        header: {
            id: 'issued.agent.directives.PolicySummary.Broker #',
            defaultMessage: 'meta.Broker',
        },
    },
];

const transformData = data => {
    const policyDataToReturn = {
        jobNumber: `${data.policyNumber}/${data.effectiveTermNumber}`,
        address: data.primaryInsuredAddress,
        name: data.primaryInsuredName,
        broker: data.brokerNumber,
        productCode: data.product.productCode,
        policyNumber: data.policyNumber,
        rowClickDestination: constants.DESTINATION_POLICIES,
    };
    return policyDataToReturn;
};

const loadDataAsyncSubmission = (page, pageSize, queryParams, authHeader) => {
    const searchCriteria = {
        searchBy: WMICTabsCommonUtil.formatSearchBy(queryParams.producerCode),
        daysLimit: constants.POLICIES_CREATED_IN_LAST_DAYS,
        resultLimit: constants.MAX_NUBER_RECENTLY_VIEWED_POLICIES,
        producerCodes: WMICTabsCommonUtil.formatProducerCodes(queryParams.producerCode),
    };

    return PolicyService.getRecentlyIssuedPolicies(searchCriteria, authHeader).then(response => {
        const simpleResponse = [];

        response.forEach(policy => {
            simpleResponse.push(transformData(policy));
        });

        return {
            rows: simpleResponse,
            numberOfRows: simpleResponse.length,
        };
    });
};

export default {
    tabHeading: messages.openRecentlyIssuedPoliciesTab,
    displayColumns,
    loadDataAsyncSubmission,
    hideFilters: true,
};
